import {NgClass} from "@angular/common";
import {Component, computed, inject, input, signal} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink} from "@angular/router";
import {MenuSidebarItem} from "../../../../core/interfaces/specific/menu-sidebar-item";
import {Tooltip} from "primeng/tooltip";
import {filter} from "rxjs";
import {map} from "rxjs/operators";
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-menu-sidebar-item',
    imports: [
        RouterLink,
        NgClass,
        Tooltip
    ],
    templateUrl: './menu-sidebar-item.component.html',
    styleUrl: './menu-sidebar-item.component.scss'
})
export class MenuSidebarItemComponent {
  private activatedRoute = inject(ActivatedRoute)
  private router = inject(Router)

  readonly menuSidebarItem = input.required<MenuSidebarItem>();

  private routeData = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.data;
      })
    ),
    { initialValue: {} }
  );

  isCurrent = computed(() => {
    const data = this.routeData();
    return (data as any)['flag'] === this.menuSidebarItem()?.flag;
  });
}
